import React from 'react'
import { Drawer, Backdrop, Box, Divider, styled } from '@mui/material'
import { withRouter } from 'react-router'
import { MobileMenuIcon } from 'packages/eid-icons'
import Menu from './Menu'
import ContentList from './Menu/ContentList'
import ContentFooter from './Menu/ContentFooter'
import ContentHeader from './Menu/ContentHeader'

const ContentWrapper = styled(Box)(({ theme }) => ({
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    padding: '0 1.5rem',
    flexDirection: 'column',
    paddingTop: '1rem',
    paddingBottom: '4.5rem',
}))

const buttonStyles = {
    position: 'absolute',
    top: '50%',
}

const StyledDrawer = styled(Drawer)(({ theme }) => ({
    '& .MuiDrawer-paper': {
        display: 'flex',
        flexDirection: 'row',
        overflow: 'visible',
        visibility: 'visible !important',
        padding: '4rem 0 0 0',
        width: '26.8rem',
    },
}))

const GlobalMenuMobile = ({
    routes,
    colorCodes,
    currentSection,
    eid,
    apps,
    hideMSAppsMenu,
    loading,
    current,
    settings,
    children,
}) => {
    const iconMenuProps = { eid, apps, loading, current }

    const [open, setOpen] = React.useState('hide')
    const handleClose = () =>
        setOpen((prev) => (prev === 'show' ? 'hide' : 'show'))

    return (
        <>
            {open === 'show' && (
                <Backdrop
                    open={open === 'show'}
                    onClick={() => setOpen('hide')}
                />
            )}

            <StyledDrawer
                variant="persistent"
                anchor="left"
                open={open === 'show'}
                onClose={() => setOpen('hide')}
            >
                {!hideMSAppsMenu && <Menu {...iconMenuProps} />}

                {children ? (
                    children(handleClose)
                ) : (
                    <ContentWrapper>
                        <ContentHeader
                            currentApp={current}
                            currentSection={currentSection}
                            onClick={() => setOpen('hide')}
                            style={{ color: colorCodes.primary }}
                        />

                        {routes && (
                            <ContentList
                                data={routes}
                                handleMenuClose={() =>
                                    setOpen((prev) =>
                                        prev === 'show' ? 'hide' : 'show',
                                    )
                                }
                            />
                        )}

                        <Divider variant="middle" />

                        <ContentFooter
                            colorCodes={colorCodes}
                            settings={settings}
                            data={[
                                {
                                    name: 'Sign Out',
                                    icon: 'LogOut',
                                    path: '/signout',
                                },
                            ]}
                        />
                    </ContentWrapper>
                )}

                <MobileMenuIcon
                    style={{
                        ...buttonStyles,
                        right: open === 'show' ? '-3.3rem' : '-3.2rem',
                    }}
                    color="#000000"
                    onClick={() =>
                        setOpen((prev) => (prev === 'show' ? 'hide' : 'show'))
                    }
                />
            </StyledDrawer>
        </>
    )
}

export default withRouter(GlobalMenuMobile)
